export enum EN_APP_DEVICE {
  IOS = 'ios',
  ANDROID = 'android',
}
